<template>
  <a class="mint-cell mint-field" :class="required?'required':''">
    <div class="mint-cell-wrapper">
      <div class="mint-cell-title">
        <span class="mint-cell-text">{{label}}</span>
      </div>
      <div class="mint-cell-value">
        <div>
          <file-upload
            :target="this.GLOBAL.serverUrl + '/attach/upload'"
            action="POST"
            class="upload-btn"
            v-on:finish="uploadFinish"
          ></file-upload>
        </div>
        <div v-if="value" class="upload-image">
          <img v-gallery :src="this.GLOBAL.serverUrl + '/attach/' + value + '/download'"/>
        </div>
      </div>
    </div>
  </a>
</template>
<script>
import Vue from "vue";
import { Toast } from "mint-ui";
import FileUpload from "vue-simple-upload/dist/FileUpload";
import gallery from "img-vuer";
Vue.use(gallery, {
  swipeThreshold: 150, // default 100
  isIndexShow: false, // show image index, default true
  useCloseButton: true, // trigger gallery close with close button, default true
  preload: true // preload images in the same group, default true
});

export default {
  name: "UploadField",
  components: {FileUpload, gallery, Toast},
  props: ["value", "label", "required"],
  methods: {
    uploadFinish(e) {
      if (e.target.status == 200) {
        var resptext = e.target.response;
        var resp = JSON.parse(resptext);
        if (resp.success) {
          this.$emit("input", resp.data[0].id);
        } else {
          Toast("图片上传失败，请稍后重试！");
        }
      }
    }
  }
};
</script>
<style scoped>
.upload-image {
  padding: 1rem;
}
.upload-image img {
  max-height: 5rem;
}
.upload-btn {
  width: 48px;
  height: 48px;
  background: url("../assets/upload.png") no-repeat;
  background-position-x: left;
  padding-left: 48px;
  box-sizing: border-box;
  overflow: hidden;
  display: inline-block;
}
</style>